module.exports = __WEBPACK_EXTERNAL_MODULE__angular_platform_browser_animations__;